/* import __COLOCATED_TEMPLATE__ from './search-result-entries.hbs'; */
import Component from "@ember/component";
import { tagName } from "@ember-decorators/component";

@tagName("")
export default class SearchResultEntries extends Component {}
